import { useQuery } from '@tanstack/react-query';
import { EventService } from '../services';
import { queryKeys } from './query-keys';
function useEventRankingQuery(eventId, params) {
  return useQuery({
    queryKey: queryKeys.eventRanking.detail(eventId, params),
    queryFn: () => EventService.getRanking(eventId, params),
    enabled: eventId !== undefined,
    staleTime: Infinity
  });
}
export default useEventRankingQuery;